import DataSet from "./DataSet";
import CommonUtil from "../../utils/CommonUtil";
import DataTable from "./DataTable";
import DataTableSchema from "./DataTableSchema";
import DataSetColDateTimeEditor from "./DataSetColDateTimeEditor";
import DataSetColLongEditor from "./DataSetColLongEditor";
import DataSetColStringEditor from "./DataSetColStringEditor";
import DataSetColTimeEditor from "./DataSetColTimeEditor";
import DataSetColDateEditor from "./DataSetColDateEditor";
import DataSetColEnumEditor from "./DataSetColEnumEditor";
import DataSetBooleanEditor from "./DataSetColBooleanEditor";
import DataSetColDecimalEditor from "./DataSetColDecimalEditor";
import StringUtil from "../../utils/StringUtil";
import { col } from "react/lib/ReactDOMFactories";
export default class DataSetUtil
{
    static strDataSet(dataSetStr,dataArray){
        var dataSet = new DataSet();
        dataSet.id = CommonUtil.guid();
        dataSet.dataTables = [];
        var dataTable = new DataTable();
        dataTable.data = [];
        var dataTableSchema = new DataTableSchema();
        dataTableSchema.id = CommonUtil.guid();
        dataTableSchema.type = "Simple";
        dataTableSchema.name = dataSetStr.queryTable.tableName.substr(dataSetStr.queryTable.tableName.lastIndexOf(".")+1);
        dataTableSchema.label = "columnsArray";
        dataTableSchema.columns = [];
        dataTableSchema.fileName=dataSetStr.fileName;//数据集名称
        dataTable.schema = dataTableSchema;
        for(let i in dataSetStr.dataColumn.columnsArray){
            let column = dataSetStr.dataColumn.columnsArray[i];
            if(column.dataType == "String"){
                var dataSetColStringEditor =  new DataSetColStringEditor();
                dataSetColStringEditor.label = column.label;
                dataSetColStringEditor.name = dataTable.schema.name+"."+StringUtil.convertToFirstLowerCase(column.columnId);
                dataSetColStringEditor.helpText = column.helpText;
                dataSetColStringEditor.displayLength = column.displayLength;
                dataSetColStringEditor.stringSize = column.stringSize;
                dataTable.schema.columns.push(dataSetColStringEditor);
            }
            if(column.dataType == "Long"){
                var dataSetColLongEditor =  new DataSetColLongEditor();
                dataSetColLongEditor.label = column.label;
                dataSetColLongEditor.name = dataTable.schema.name+"."+StringUtil.convertToFirstLowerCase(column.columnId);
                dataSetColLongEditor.showZero = column.showZero;
                dataSetColLongEditor.thousandSeperator = column.thousandSeperator;
                dataSetColLongEditor.helpText = column.helpText;
                dataSetColLongEditor.displayLength = column.displayLength;
                dataTable.schema.columns.push(dataSetColLongEditor);
            }
            if(column.dataType == "Boolean"){
                var dataSetBooleanEditor =  new DataSetBooleanEditor();
                dataSetBooleanEditor.label = column.label;
                dataSetBooleanEditor.name = dataTable.schema.name+"."+StringUtil.convertToFirstLowerCase(column.columnId);
                dataSetBooleanEditor.textFalse = column.textTrue;
                dataSetBooleanEditor.textTrue = column.textTrue;
                dataSetBooleanEditor.helpText = column.helpText;
                dataSetBooleanEditor.displayLength = column.displayLength;
                dataTable.schema.columns.push(dataSetBooleanEditor);
            }
            if(column.dataType == "Decimal"){
                var dataSetColDecimalEditor =  new DataSetColDecimalEditor();
                dataSetColDecimalEditor.label = column.label;
                dataSetColDecimalEditor.name = dataTable.schema.name+"."+StringUtil.convertToFirstLowerCase(column.columnId);
                dataSetColDecimalEditor.helpText = column.helpText;
                dataSetColDecimalEditor.displayLength = column.displayLength;
                dataSetColDecimalEditor.showZero = column.showZero;
                dataSetColDecimalEditor.thousandSeperator = column.thousandSeperator;
                dataSetColDecimalEditor.numOfDecimals = column.numOfDecimals;
                dataSetColDecimalEditor.showDecimals = column.showDecimals;
                dataSetColDecimalEditor.currencyType = column.currencyType;
                dataSetColDecimalEditor.currencyPrefix = column.currencyPrefix;
                dataSetColDecimalEditor.percentage = column.percentage;
                dataTable.schema.columns.push(dataSetColDecimalEditor);
            }
            if(column.dataType == "Date"){
                var dataSetColDateEditor =  new DataSetColDateEditor();
                dataSetColDateEditor.label = column.label;
                dataSetColDateEditor.name = dataTable.schema.name+"."+StringUtil.convertToFirstLowerCase(column.columnId);
                dataSetColDateEditor.helpText = column.helpText;
                dataSetColDateEditor.displayLength = column.displayLength;
                dataSetColDateEditor.displayFormat = column.displayFormat;
                dataTable.schema.columns.push(dataSetColDateEditor);
            }
            if(column.dataType == "Time"){
                var dataSetColTimeEditor =  new DataSetColTimeEditor();
                dataSetColTimeEditor.label = column.label;
                dataSetColTimeEditor.name = dataTable.schema.name+"."+StringUtil.convertToFirstLowerCase(column.columnId);
                dataSetColTimeEditor.helpText = column.helpText;
                dataSetColTimeEditor.displayLength = column.displayLength;
                dataSetColTimeEditor.displayFormat = column.displayFormat;
                dataTable.schema.columns.push(dataSetColTimeEditor);
            }
            if(column.dataType == "DataTime"){
                var dataSetColDateTimeEditor =  new DataSetColDateTimeEditor();
                dataSetColDateTimeEditor.label = column.label;
                dataSetColDateTimeEditor.name = dataTable.schema.name+"."+StringUtil.convertToFirstLowerCase(column.columnId);
                dataSetColDateTimeEditor.helpText = column.helpText;
                dataSetColDateTimeEditor.displayLength = column.displayLength;
                dataSetColDateTimeEditor.displayFormat = column.displayFormat;
                dataTable.schema.columns.push(dataSetColDateTimeEditor);
            }
            if(column.dataType == "Enum"){
                var dataSetColEnumEditor =  new DataSetColEnumEditor();
                dataSetColEnumEditor.label = column.label;
                dataSetColEnumEditor.name = dataTable.schema.name+"."+StringUtil.convertToFirstLowerCase(column.columnId);
                dataSetColEnumEditor.helpText = column.helpText;
                dataSetColEnumEditor.displayLength = column.displayLength;
                dataSetColEnumEditor.enumItems = column.DataProvider;
                dataTable.schema.columns.push(dataSetColEnumEditor);
            }
          }
          if(dataArray){
            dataTable.data = dataArray;
          }
          dataSet.dataTables.push(dataTable);
          return dataSet;
    }

}


// WEBPACK FOOTER //
// ./src/universalView/dataSet/DataSetUtil.js